import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  url = `/api/login`;

  constructor(
    private http: HttpClient
  ) { }

  initLogin(payload: any): Observable<any> {
    return this.http.post<any>(`${this.url}`, payload).pipe(
      map((res: any) => {
        localStorage.setItem('id_token_api', res.access_token);
        localStorage.setItem('usr', res.user);
        return res;
      })
    );
  }
  
  logout() {
    return this.http.post<any>(`/api/logout`, {}).pipe(
      map((res: any) => {
      localStorage.removeItem('id_token_api');
      localStorage.removeItem('usr');
        return res;
      })
    );
  }
  
  newUser(payload: any) {
    return this.http.post<any>(`/api/registerNewUser`, payload).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  
  updatePassword(payload: any) {
    return this.http.post<any>(`/api/updatePassword`, payload).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  requestPassword(payload: any) {
    return this.http.get<any>(`/api/requestPassword?usr=${payload}`).pipe(
      map((res: any) => {
        return res; 
      })
    );
  }
}
